module.exports = __webpack_public_path__ + "img/beijing.e3d3f736.png";